import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      // Navigation
      "home": "Home",
      "myGroups": "My Groups",
      "settings": "Settings",
      "logout": "Logout",
      
      // Home Page
      "welcomeTitle": "Welcome to Jingolin",
      "welcomeSubtitle": "Organize your Secret Santa gift exchanges online - free, easy, and fun!",
      "createGroup": "Create New Group",
      "sendLogin": "Send Login Link",
      "joinGroup": "Join Group",
      "howItWorks": "How It Works",
      "step1": "Create or join a Secret Santa group",
      "step2": "Add your wishlist and shipping address",
      "step3": "Admin performs the draw",
      "step4": "See who you're gifting to and start shopping!",
      
      // Auth
      "loginTitle": "Login to Jingolin",
      "email": "Email",
      "name": "Name",
      "sendMagicLink": "Send Magic Link",
      "checkEmail": "Check your email for the magic link!",
      
      // Create Group
      "createGroupTitle": "Create Secret Santa Group",
      "createGroupDescription": "Describe your group and set the details for your Secret Santa exchange.",
      "groupName": "Group Name",
      "budget": "Budget (optional)",
      "giftDate": "Gift Exchange Date",
      "theme": "Theme (optional)",
      "create": "Create",
      "cancel": "Cancel",
      
      // Group Dashboard
      "TimeUntilGiftExchange": "Time Until Gift Exchange",
      "inviteCode": "Invite Code",
      "copyInviteLink": "Copy Invite Link",
      "participants": "Participants",
      "daysUntil": "Days Until Gift Exchange",
      "performDraw": "Perform Draw",
      "viewResult": "View Your Match",
      "addWishlist": "Add to Wishlist",
      "myWishlist": "My Wishlist",
      "myAddress": "My Address",
      "groupProgress": "Group Progress",
      "wishlistsAdded": "Wishlists Added",
      "addressesAdded": "Addresses Added",

      // Delete Group
      "deleteGroup": "Delete Group",
      "deleteGroupDescription": "Are you sure you want to delete this group? This action cannot be undone.",
      "confirmDelete": "Delete Group",
    
      
      // Draw Results
      "yourMatch": "Your Secret Santa Match",
      "giftingTo": "You are gifting to",
      "theirWishlist": "Their Wishlist",
      "theirAddress": "Their Address",
      "sendAnonymousMessage": "Send Anonymous Message",
      "noWishlist": "No wishlist items yet",
      "noAddress": "No address provided",
      
      // Wishlist
      "wishlist": "Wishlist",
      "wishlistTitle": "Wishlist Item",
      "itemName": "Item Name",
      "description": "Description",
      "link": "Link",
      "price": "Price",
      "addItem": "Add Item",
      "delete": "Delete",

      // Suggestions
      "giftIdeas": "Gift Ideas",
      "giftIdeasSubtitle": "Get curated affiliate suggestions based on age, gender, and interests.",
      "ageFilterLabel": "Age",
      "genderFilterLabel": "Gender",
      "interestsFilterLabel": "Interests",
      "budgetFilterLabel": "Max Budget",
      "interestsPlaceholder": "e.g., books, gaming, wellness",
      "findGiftIdeas": "Find Gift Ideas",
      "loadingIdeas": "Fetching ideas...",
      "noSuggestions": "No suggestions match your filters yet.",
      "addToWishlistFromSuggestions": "Add to Wishlist",
      "viewOffer": "View Offer",
      "suggestionAdded": "Suggestion added to your wishlist!",
      "suggestionAddFailed": "Could not add the suggestion to your wishlist.",
      "suggestionsLoadFailed": "Could not load gift ideas.",
      "genderAny": "Any",
      "genderFemale": "Female",
      "genderMale": "Male",
      "genderNonBinary": "Non-binary",
      
      // Address
      "addressTitle": "Shipping Address",
      "addressPlaceholder": "Enter your shipping address",
      "saveAddress": "Save Address",
      
      // Messages
      "messagesTitle": "Messages",
      "sendMessage": "Send Message",
      "messageText": "Message",
      "noMessages": "No messages yet",
      
      // Settings
      "settingsTitle": "Settings",
      "language": "Language",
      "theme": "Theme",
      "dark": "Dark",
      "light": "Light",
      
      // Common
      "loading": "Loading...",
      "save": "Save",
      "close": "Close",
      "copied": "Copied!",
      "error": "Error",
      "success": "Success"
    }
  },
  de: {
    translation: {
      // Navigation
      "home": "Startseite",
      "myGroups": "Meine Gruppen",
      "settings": "Einstellungen",
      "logout": "Abmelden",
      
      // Home Page
      "welcomeTitle": "Willkommen bei Jingolin",
      "welcomeSubtitle": "Organisiere deine Wichtel-Geschenkaustausche online - kostenlos, einfach und lustig!",
      "createGroup": "Neue Gruppe erstellen",
      "sendLogin": "Login-Link senden",
      "joinGroup": "Gruppe beitreten",
      "howItWorks": "So funktioniert's",
      "step1": "Wichtel-Gruppe erstellen oder beitreten",
      "step2": "Wunschliste und Versandadresse hinzufügen",
      "step3": "Admin führt die Auslosung durch",
      "step4": "Sehe, wem du schenkst und starte das Einkaufen!",
      
      // Auth
      "loginTitle": "Bei Jingolin anmelden",
      "email": "E-Mail",
      "name": "Name",
      "sendMagicLink": "Magic Link senden",
      "checkEmail": "Überprüfe deine E-Mail für den Magic Link!",
      
      // Create Group
      "createGroupTitle": "Wichtel-Gruppe erstellen",
      "createGroupDescription": "Beschreibe deine Gruppe und lege die Details für deinen Wichtel-Geschenkaustausch fest.",
      "groupName": "Gruppenname",
      "budget": "Budget (optional)",
      "giftDate": "Geschenkaustausch-Datum",
      "theme": "Thema (optional)",
      "create": "Erstellen",
      "cancel": "Abbrechen",

      // Delete Group
      "deleteGroup": "Gruppe löschen",
      "deleteGroupDescription": "Möchten Sie diese Gruppe wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.",
      "confirmDelete": "Gruppe löschen",
      
      // Group Dashboard
      "TimeUntilGiftExchange": "Zeit bis zum Geschenkaustausch",
      "inviteCode": "Einladungscode",
      "copyInviteLink": "Einladungslink kopieren",
      "participants": "Teilnehmer",
      "daysUntil": "Tage bis zum Geschenkaustausch",
      "performDraw": "Auslosung durchführen",
      "viewResult": "Dein Match ansehen",
      "addWishlist": "Zur Wunschliste hinzufügen",
      "myWishlist": "Meine Wunschliste",
      "myAddress": "Meine Adresse",
      "groupProgress": "Gruppenfortschritt",
      "wishlistsAdded": "Wunschlisten hinzugefügt",
      "addressesAdded": "Adressen hinzugefügt",
      
      // Draw Results
      "yourMatch": "Dein Wichtel-Match",
      "giftingTo": "Du schenkst an",
      "theirWishlist": "Deren Wunschliste",
      "theirAddress": "Deren Adresse",
      "sendAnonymousMessage": "Anonyme Nachricht senden",
      "noWishlist": "Noch keine Wunschlistenartikel",
      "noAddress": "Keine Adresse angegeben",
      
      // Wishlist
      "wishlist": "Wunschliste",
      "wishlistTitle": "Wunschlistenartikel",
      "itemName": "Artikelname",
      "description": "Beschreibung",
      "link": "Link",
      "price": "Preis",
      "addItem": "Artikel hinzufügen",
      "delete": "Löschen",

      // Suggestions
      "giftIdeas": "Geschenkideen",
      "giftIdeasSubtitle": "Erhalte passende Affiliate-Vorschläge basierend auf Alter, Geschlecht und Interessen.",
      "ageFilterLabel": "Alter",
      "genderFilterLabel": "Geschlecht",
      "interestsFilterLabel": "Interessen",
      "budgetFilterLabel": "Max. Budget",
      "interestsPlaceholder": "z. B. Bücher, Gaming, Wellness",
      "findGiftIdeas": "Geschenkideen finden",
      "loadingIdeas": "Ideen werden geladen...",
      "noSuggestions": "Keine Vorschläge für diese Filter gefunden.",
      "addToWishlistFromSuggestions": "Zur Wunschliste hinzufügen",
      "viewOffer": "Affiliate-Angebot öffnen",
      "suggestionAdded": "Vorschlag zur Wunschliste hinzugefügt!",
      "suggestionAddFailed": "Vorschlag konnte nicht zur Wunschliste hinzugefügt werden.",
      "suggestionsLoadFailed": "Geschenkideen konnten nicht geladen werden.",
      "genderAny": "Egal",
      "genderFemale": "Weiblich",
      "genderMale": "Männlich",
      "genderNonBinary": "Divers",
      
      // Address
      "addressTitle": "Versandadresse",
      "addressPlaceholder": "Gib deine Versandadresse ein",
      "saveAddress": "Adresse speichern",
      
      // Messages
      "messagesTitle": "Nachrichten",
      "sendMessage": "Nachricht senden",
      "messageText": "Nachricht",
      "noMessages": "Noch keine Nachrichten",
      
      // Settings
      "settingsTitle": "Einstellungen",
      "language": "Sprache",
      "theme": "Thema",
      "dark": "Dunkel",
      "light": "Hell",
      
      // Common
      "loading": "Lädt...",
      "save": "Speichern",
      "close": "Schließen",
      "copied": "Kopiert!",
      "error": "Fehler",
      "success": "Erfolg"
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
